module.exports = __webpack_public_path__ + "static/media/test-cloud.1a66dec4.svg";